var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"customer-awaiting-receipt-list",attrs:{"screenConfig":_vm.setScreenConfig,"setLoading":_vm.setLoading,"persistenceKey":'customer-awaiting-receipt'}})
}
var staticRenderFns = []

export { render, staticRenderFns }